import {createContext, useContext} from "react";
import type {CustomerBrand} from "account/AccountBrandApi";

/**
 * How the branding sheet tells the app theme that the account's brand changed (kitecorp/transferify-ui#2935).
 *
 * The app theme loads the brand once per session; without this, a colour saved in the sheet would only
 * reach the rest of the app on the next page load. A no-op outside the provider, so a hook rendered on its
 * own (a unit test) needs no theme around it.
 */
export const AccountAppColorContext = createContext<(brand: Pick<CustomerBrand, "primaryColor">) => void>(() => {});

/** The publisher {@link AccountAppColorContext} carries. */
export function useAccountAppColorPublisher(): (brand: Pick<CustomerBrand, "primaryColor">) => void {
	return useContext(AccountAppColorContext);
}
